import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectMortgageMiniCalculatorSuburbanEnabled = (state: IState) => {
  return featureToggleSelector(state).isMortgageCalculatorInSuburbanCardEnabled;
};
